module.exports = __webpack_public_path__ + "img/1.3cb14b45.jpg";